//import api from '@/services/api';
import {api} from "../main";

export default{
    updateEntregable(activityId, tipoEntregable ){
    
        let url                   = `/api/actividades/update/entregable/${activityId}/${tipoEntregable}`;
        let response     = api({
            url: url,
            method: 'GET',
            headers: {
                'Access-Control-Allow-Headers': 'X-Requested-With, Content-Type, X-Token-Auth, Authorization',
            }     
        });
        return response;
        
    },
    updateItemActivity(idItem,descripcion_actividad){
        let url = `/api/actividad/items/update/${idItem}`;
        let response     = api({
            url: url,
            method: 'PUT',
            headers: {
                'Access-Control-Allow-Headers': 'X-Requested-With, Content-Type, X-Token-Auth, Authorization',
            },
            data: {
                descripcion_actividad : descripcion_actividad,
            }          
        });
        return response;
    }
    ,deleteItemActivity(id){
        let url = `/api/actividad/items/destroy/${id}`;
        let response     = api({
            url: url,
            method: 'DELETE',
            headers: {
                'Access-Control-Allow-Headers': 'X-Requested-With, Content-Type, X-Token-Auth, Authorization',
            }
        });
 
        return response;
    },
    saveItemActividad(formData){
        let url          = `/api/actividad/items/store`;
        let response     = api({
            url: url,
            method: 'POST',
            headers: {
                'Access-Control-Allow-Headers': 'X-Requested-With, Content-Type, X-Token-Auth, Authorization',
            },
            data: formData 
        });
 
        return response;
    },
    getItemsEnActividad(idActividad){
        let url        = `/api/actividad/items/show/${idActividad}`;
        let response   = api({
            url: url,
            method: 'GET',
            headers: {
                'Access-Control-Allow-Headers': 'X-Requested-With, Content-Type, X-Token-Auth, Authorization',
            }
        });
        return response;
    },
    updateUnidadActividad(idActividadUnidad,nombre_actividad_unidad, form_link = null){
        let url          = `/api/actividades/actividad-unidad/update/${idActividadUnidad}`; 
        let data = {
            nombre_actividad_unidad : nombre_actividad_unidad,
        };
        
        // Solo agregar form_link si se proporciona
        if (form_link !== null && form_link !== '') {
            data.form_link = form_link;
        }
        
        let response     = api({
            url: url,
            method: 'PUT',
            headers: {
                'Access-Control-Allow-Headers': 'X-Requested-With, Content-Type, X-Token-Auth, Authorization',
            },
            data: data          
             
        });
        return response;
    },
    updateUnidadActividadEntregableOpcional(idActividadUnidad,entregable_opcional){

        console.log("idActividadUnidad");//1058 id actividad
        console.log(idActividadUnidad);

        console.log("entregable_opcional");//1 o 2
        console.log(entregable_opcional);

        let url          = `/api/entregablesOpcional/update/${idActividadUnidad}`;
        let response     = api({
            url: url,
            method: 'PUT',
            headers: {
                'Access-Control-Allow-Headers': 'X-Requested-With, Content-Type, X-Token-Auth, Authorization',
            },
            data: {
                entregable_opcional : entregable_opcional,
            }

        });
        return response;
    },
    deleteActividadUnidad(idActividadUnidad){
                
        let url          = `/api/actividades/actividad-unidad/destroy/${idActividadUnidad}`;
        let response     = api({
            url: url,
            method: 'DELETE',
            headers: {
                'Access-Control-Allow-Headers': 'X-Requested-With, Content-Type, X-Token-Auth, Authorization',
            }
        });
        return response;
    },
    saveUnidadActividad(formData){
        let url          = `/api/actividades/store`;
        let response     = api({
            url: url,
            method: 'POST',
            headers: {
                'Access-Control-Allow-Headers': 'X-Requested-With, Content-Type, X-Token-Auth, Authorization',
            },
            data: formData 
        });
        return response;
    },
    getUnidadActivitidades(itemId){
        let url          = `/api/actividades/actividad-unidad/all-actividades/${itemId}`;
        let response   = api({
            url: url,
            method: 'GET',
            headers: {
                'Access-Control-Allow-Headers': 'X-Requested-With, Content-Type, X-Token-Auth, Authorization',
            }
        });
        return response;
    },

    updateActivityExamenAvanza(idActividad,idExamenAvanza){
        let url = `/api/actividades/actividad-unidad/avanza/update/${idActividad}`;
        let response     = api({
            url: url,
            method: 'PUT',
            headers: {
                'Access-Control-Allow-Headers': 'X-Requested-With, Content-Type, X-Token-Auth, Authorization',
            },
            data: {
                idExamenAvanza : idExamenAvanza,
            }
        });
        return response;
    }

}